import React, { useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Summary from './Summary';
import PayoutDetails from './PayoutDetails';

import RawData from 'components/RawData';
import Loader from 'components/Loader';
import DashboardContainer from 'components/DashboardContainer';
import BreadCrumbs from 'components/BreadCrumbs';
import WebhookTable from 'pages/Webhooks/WebhookTable';
import TransferTable from 'pages/Transfers/TransferTable';

import { payoutDetails as TEXT } from 'locales/en/payout';
import {
  getPayoutsById,
  getPayoutWebhooks,
  getPayoutTransfers,
  payoutByIdSelector,
} from 'redux/slices/payout';

const PayoutDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { data: payout, isLoading } = useSelector((state) =>
    payoutByIdSelector(state, id)
  );
  const isDevOrSuperAdmin = useSelector(
    (state) => state.auth.user.isDevOrSuperAdmin
  );
  useEffect(() => {
    if (!isLoading) {
      dispatch(getPayoutsById(id));
    }
    dispatch(getPayoutTransfers({ payout_id: id }));
    dispatch(getPayoutWebhooks({ payout_id: id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onTransferPageChange = ({ selected }) => {
    return dispatch(getPayoutTransfers({ payout_id: id, page: selected + 1 }));
  };

  const onWebhookPageChange = ({ selected }) => {
    return dispatch(getPayoutWebhooks({ payout_id: id, page: selected + 1 }));
  };

  const rawJSON = useMemo(() => {
    return JSON.stringify(payout?.raw, null, 2);
  }, [payout]);

  if (isLoading) return <Loader />;

  return !!payout ? (
    <>
      <BreadCrumbs screen="payout" />
      <DashboardContainer header={`${TEXT.header1} ${id}`}>
        <Summary payout={payout} />
        <PayoutDetails payout={payout} />
        <RawData json={rawJSON} title={TEXT.rawDataHeader} />
        {!!payout.transfers?.data?.length && (
          <TransferTable
            isDetail
            title={TEXT.transferHeader}
            data={payout.transfers.data}
            onPageChange={onTransferPageChange}
            pagination={payout.transfers.pagination}
          />
        )}
        {!!payout.webhooks?.data?.length && isDevOrSuperAdmin && (
          <WebhookTable
            isDetail
            title={TEXT.webhookHeader}
            data={payout.webhooks.data}
            onPageChange={onWebhookPageChange}
            pagination={payout.webhooks.pagination}
          />
        )}
      </DashboardContainer>
    </>
  ) : null;
};

export default PayoutDetail;
